var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTime = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666564",
    fillRule: "evenodd",
    d: "M10 8H8.667V6.667C8.667 6.298 8.368 6 8 6c-.368 0-.667.298-.667.667v2c0 .368.299.666.667.666h2c.368 0 .667-.298.667-.666 0-.369-.299-.667-.667-.667m-2 5.167c-2.481 0-4.5-2.019-4.5-4.5 0-2.482 2.019-4.5 4.5-4.5s4.5 2.018 4.5 4.5c0 2.481-2.019 4.5-4.5 4.5m.659-10.462c.001-.014.008-.024.008-.038V2h.666c.368 0 .667-.298.667-.667 0-.368-.299-.666-.667-.666H6.667C6.299.667 6 .965 6 1.333c0 .369.299.667.667.667h.666v.667c0 .014.007.024.008.038C4.342 3.035 2 5.581 2 8.667c0 3.308 2.692 6 6 6s6-2.692 6-6c0-3.086-2.342-5.632-5.341-5.962",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTime, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/time.94a2e7ae.svg";
export { ForwardRef as ReactComponent };